// Import emote images from assets directory so Bun bundles them
import angryImg from "@/assets/emotes/angry.png";
import badLuckImg from "@/assets/emotes/bad-luck.png";
import heartImg from "@/assets/emotes/heart.png";
import laughImg from "@/assets/emotes/laugh.png";
import thinkingImg from "@/assets/emotes/thinking.png";
import thumbsUpImg from "@/assets/emotes/thumbs-up.png";
import { Constants } from "@nextgammon/shared";

export interface Emote {
  id: Constants.EmoteId;
  img: string; // Bundled image path
}

// All emotes preloaded
export const EMOTES: Emote[] = [
  { id: "thumbs_up", img: thumbsUpImg },
  { id: "laugh", img: laughImg },
  { id: "thinking", img: thinkingImg },
  { id: "bad_luck", img: badLuckImg },
  { id: "angry", img: angryImg },
  { id: "heart", img: heartImg }
];

// Simple lookup helper
export function getEmote(emoteId: Constants.EmoteId): Emote | undefined {
  return EMOTES.find((e) => e.id === emoteId);
}
